import { render, staticRenderFns } from "./SalesLimitContent.template.vue?vue&type=template&id=4ffa8bec&scoped=true&"
var script = {}
import style0 from "./SalesLimitContent.template.vue?vue&type=style&index=0&id=4ffa8bec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffa8bec",
  null
  
)

export default component.exports